import React from 'react';
import { observer } from "mobx-react";
import {useParams} from "react-router-dom";
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Table from 'react-bootstrap/Table'

import { roundAndFormat } from '../lib/strFormatting'
import { getStateCode } from '../lib/geoUtils'

import {
    countyCovidIntervalDataStore,
    stateCovidIntervalDataStore,
    regionCovidDataStore
} from '../store/apiStores'

import './CovidCasesDeathsTable.css'

export default observer(function CovidCasesDeathsTable(props) {

    let casesData = {
        category: 'cases',
        total: 'n/a',
        new: null,
        rankUS: 'n/a',
        rankState: null,
        last7: 'n/a',
        last14: 'n/a',
        last14Rate: 'n/a'
    }
    let deathsData = {
        category: 'deaths',
        total: 'n/a',
        new: null,
        rankUS: 'n/a',
        rankState: null,
        last7: 'n/a',
        last14: '',
        last14Rate: ''
    }

    let stateCode = props.state && getStateCode(props.state)


    if (props.county) {
        if (countyCovidIntervalDataStore.data){
            try {
                let d = countyCovidIntervalDataStore.data[0];
                casesData.total = d.confirmed_current.toLocaleString()
                casesData.new = d.confirmed_yesterday.toLocaleString()
                deathsData.total = d.deaths_current.toLocaleString()
                deathsData.new = d.deaths_yesterday.toLocaleString()

                casesData.last7 = roundAndFormat(d.confirmed_last_7 / 7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14 = roundAndFormat(d.confirmed_last_14 /14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14Rate = roundAndFormat(d.confirmed_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last7RankUS = d.confirmed_last_7_rank_national.toLocaleString()
                casesData.last7RankState = d.confirmed_last_7_rank_state.toLocaleString()
                casesData.last14RankUS = d.confirmed_last_14_rank_national.toLocaleString()
                casesData.last14RankState = d.confirmed_last_14_rank_state.toLocaleString()
                casesData.last14RateRankUS = d.confirmed_last_14_per_100k_rank_national.toLocaleString()
                casesData.last14RateRankState = d.confirmed_last_14_per_100k_rank_state.toLocaleString()

                deathsData.last7 = roundAndFormat(d.deaths_last_7 / 7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14 = roundAndFormat(d.deaths_last_14 /14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14Rate = roundAndFormat(d.deaths_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last7RankUS = d.deaths_last_7_rank_national.toLocaleString()
                deathsData.last7RankState = d.deaths_last_7_rank_state.toLocaleString()
                deathsData.last14RankUS = d.deaths_last_14_rank_national.toLocaleString()
                deathsData.last14RankState = d.deaths_last_14_rank_state.toLocaleString()
                deathsData.last14RateRankUS = d.deaths_last_14_per_100k_rank_national.toLocaleString()
                deathsData.last14RateRankState = d.deaths_last_14_per_100k_rank_state.toLocaleString()

                casesData.totalRankUS = d.confirmed_current_rank_national.toLocaleString()
                deathsData.totalRankUS = d.deaths_current_rank_national.toLocaleString()
                casesData.totalRankState = d.confirmed_current_rank_state.toLocaleString()
                deathsData.totalRankState = d.deaths_current_rank_state.toLocaleString()

                casesData.newRankUS = d.confirmed_yesterday_rank_national.toLocaleString()
                deathsData.newRankUS = d.deaths_yesterday_rank_national.toLocaleString()
                casesData.newRankState = d.confirmed_yesterday_rank_state.toLocaleString()
                deathsData.newRankState = d.deaths_yesterday_rank_state.toLocaleString()
            } catch(e){}
        }
    } else if (props.state) {
        if (stateCovidIntervalDataStore.data) {
            try {
                let d = stateCovidIntervalDataStore.data[0];
                casesData.total = d.confirmed_current.toLocaleString()
                casesData.new = d.confirmed_yesterday.toLocaleString()
                deathsData.total = d.deaths_current.toLocaleString()
                deathsData.new = d.deaths_yesterday.toLocaleString()

                casesData.last7 = roundAndFormat(d.confirmed_last_7 / 7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14 = roundAndFormat(d.confirmed_last_14 /14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14Rate = roundAndFormat(d.confirmed_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last7RankUS = d.confirmed_last_7_rank_national.toLocaleString()
                casesData.last14RankUS = d.confirmed_last_14_rank_national.toLocaleString()
                casesData.last14RateRankUS = d.confirmed_last_14_per_100k_rank_national.toLocaleString()

                deathsData.last7 = roundAndFormat(d.deaths_last_7 / 7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14 = roundAndFormat(d.deaths_last_14 /14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14Rate = roundAndFormat(d.deaths_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last7RankUS = d.deaths_last_7_rank_national.toLocaleString()
                deathsData.last14RankUS = d.deaths_last_14_rank_national.toLocaleString()
                deathsData.last14RateRankUS = d.deaths_last_14_per_100k_rank_national.toLocaleString()
                casesData.totalRankUS = d.confirmed_current_rank_national.toLocaleString()
                deathsData.totalRankUS = d.deaths_current_rank_national.toLocaleString()
                casesData.newRankUS = d.confirmed_yesterday_rank_national.toLocaleString()
                deathsData.newRankUS = d.deaths_yesterday_rank_national.toLocaleString()
            } catch(e){}
        }
    } else {
        if (regionCovidDataStore.data) {
            try {
                let d = regionCovidDataStore.data[0];
                casesData.new = d.confirmed_difference.toLocaleString()
                casesData.total = d.confirmed.toLocaleString()
                casesData.last7 = roundAndFormat(d.cdtrailing7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14 = roundAndFormat(d.cdtrailing14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                casesData.last14Rate = roundAndFormat(d.confirmed_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.new = d.deaths_difference.toLocaleString()
                deathsData.total = d.deaths.toLocaleString()
                deathsData.last7 = roundAndFormat(d.ddtrailing7, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14 = roundAndFormat(d.ddtrailing14, {decimalPlace: 0.1, noFractionForLargerVals: false})
                deathsData.last14Rate = roundAndFormat(d.deaths_last_14_per_100k, {decimalPlace: 0.1, noFractionForLargerVals: false})

            } catch(e){}
        }
    }

    return (
        <Container className="covid-county-cases-and-deaths" fluid={true}>
            <h4>COVID</h4>
            <Row>
                <Col md={{span:6}}>
                    <DataTable dataType='Cases' data={casesData}
                    stateCode={stateCode} state={props.state}
                    county={props.county} />
                </Col>
                <Col md={{span:6}}>
                    <DataTable dataType='Deaths' data={deathsData}
                    stateCode={stateCode} state={props.state}
                    county={props.county} />
                </Col>
            </Row>
        </Container>

    )
})

function DataTable(props) {
    // one extra column on state page; two extra on county page
    let emptyRowColSpan = 3
        + (props.state && 1 || 0)
        + (props.county && 1 || 0);

    return (
        <Table borderless={true}>
            <thead>
                <tr>
                    <th></th>
                    <th className="text-align-right">
                        <div className="title">{props.dataType}</div>
                    </th>
                    {(props.county || props.state) && (
                        <th className="text-align-right">
                            <div className="title">Rank</div>
                            <div className="sub-title">In US</div>
                        </th>
                    )}
                    {props.county && (
                        <th className="text-align-right">
                            <div className="title">Rank</div>
                            <div className="sub-title">In {props.stateCode}</div>
                        </th>
                    )}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className={'header-cell'}>Total</td>
                    <td className="text-align-right">{props.data.total}</td>
                    {(props.county || props.state) && (
                        <td className="text-align-right">{props.data.totalRankUS}</td>
                    )}
                    {props.county && (
                        <td className="text-align-right">{props.data.totalRankState}</td>
                    )}
                </tr>
                <tr><td className="filler-row" colSpan={emptyRowColSpan}></td></tr>
                <tr>
                    <td className={'header-cell'} colSpan={emptyRowColSpan}>Daily</td>
                </tr>
                <tr>
                    <td className="label-cell">Yesterday</td>
                    <td className="text-align-right">{props.data.new}</td>
                    {(props.county || props.state) && (
                        <td className="text-align-right">{props.data.newRankUS}</td>
                    )}
                    {props.county && (
                        <td className="text-align-right">{props.data.newRankState}</td>
                    )}
                </tr>
                <tr>
                    <td className={'label-cell'}>Avg past 7d</td>
                    <td className="text-align-right">{props.data.last7}</td>
                    {(props.county || props.state) && (
                        <td className="text-align-right">{props.data.last7RankUS}</td>
                    )}
                    {props.county && (
                        <td className="text-align-right">{props.data.last7RankState}</td>
                    )}
                </tr>
                <tr>
                    <td className={'label-cell'}>Avg past 14d</td>
                    <td className="text-align-right">{props.data.last14}</td>
                    {(props.county || props.state) && (
                        <td className="text-align-right">{props.data.last14RankUS}</td>
                    )}
                    {props.county && (
                        <td className="text-align-right">{props.data.last14RankState}</td>
                    )}
                </tr>
                <tr><td className="filler-row" colSpan={emptyRowColSpan}></td></tr>
                <tr>
                    <td className={'header-cell'} colSpan={emptyRowColSpan}>Rate</td>
                </tr>
                <tr>
                    <td className={'label-cell'}>14d {props.data.category} / 100K</td>
                    <td className="text-align-right">{props.data.last14Rate}</td>
                    {(props.county || props.state) && (
                        <td className="text-align-right">{props.data.last14RateRankUS}</td>
                    )}
                    {props.county && (
                        <td className="text-align-right">{props.data.last14RateRankState}</td>
                    )}
                </tr>
            </tbody>
        </Table>
    )
}
